module.exports = __webpack_public_path__ + "static/media/archibot-bouche-classique.f873362f.gif";